import React from "react";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import DefaultButton from "../../styles/materialButtonStyle";
import { BALANCE_NOTIFICATION_ACTION_URL, STANDARD_ERRORS_WAY } from "../../../utils/consts";
import { parseAxiosError } from "../../../utils/response";

const BalanceNotificationButton = ({ notification, setNotification, userId = null }) => {

  const handleClick = () => {
    let balanceNotificationUrl = BALANCE_NOTIFICATION_ACTION_URL.admin;

    if(userId) {
      balanceNotificationUrl = BALANCE_NOTIFICATION_ACTION_URL.user + userId
    }

    axios.get(balanceNotificationUrl, userAuthenticationConfig()).then(response => {
      if (response.status === 204) {
        setNotification({ ...notification, visible: true, type: "success", message: "Колбек успешно отправлен" });
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <div className="balance-notification-wrapper">
      <DefaultButton
        color="success"
        onClick={handleClick}
      >
        Send to Telegram
      </DefaultButton>
    </div>

  );
};

export default BalanceNotificationButton;